"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CombinedSessionItem = require("./CombinedSessionItem");
Object.keys(_CombinedSessionItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CombinedSessionItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CombinedSessionItem[key];
    }
  });
});
var _CombinedTokenStorage = require("./CombinedTokenStorage");
Object.keys(_CombinedTokenStorage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CombinedTokenStorage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CombinedTokenStorage[key];
    }
  });
});
var _OidcTokenStorage = require("./OidcTokenStorage");
Object.keys(_OidcTokenStorage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OidcTokenStorage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OidcTokenStorage[key];
    }
  });
});
var _SessionStorage = require("./SessionStorage");
Object.keys(_SessionStorage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SessionStorage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SessionStorage[key];
    }
  });
});
var _SessionTokenStorage = require("./SessionTokenStorage");
Object.keys(_SessionTokenStorage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SessionTokenStorage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SessionTokenStorage[key];
    }
  });
});
var _SessionValue = require("./SessionValue");
Object.keys(_SessionValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SessionValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SessionValue[key];
    }
  });
});
var _StorageItem = require("./StorageItem");
Object.keys(_StorageItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StorageItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StorageItem[key];
    }
  });
});
var _TokenStorage = require("./TokenStorage");
Object.keys(_TokenStorage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TokenStorage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TokenStorage[key];
    }
  });
});
//# sourceMappingURL=index.js.map